import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export class DataService<T> {
  constructor(
    protected url: string,
    protected http: HttpClient
  ) { }

  getAll(url: string = this.url): Observable<T[]> {
    return this.http.get<T[]>(url);
  }

  getByID(id, url: string = this.url): Observable<T> {
    return this.http.get<T>(url + id);
  }

  create(resource, url: string = this.url): Observable<any> {
    return this.http.post(url, JSON.stringify(resource),
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      });
  }

  update(resource): Observable<any> {
    return this.http.put(this.url, resource);
  }

  updateById(id, resource, url: string = this.url): Observable<any> {
    return this.http.put(url + id, resource);
  }

  delete(id): Observable<any> {
    return this.http.delete(this.url + id);
  }
}
